<template>
	<div class="QuestionTypeList">
		<el-collapse v-model="collapseVisible">
			<el-collapse-item v-for="(item, index) in typeObj" :key="index" :title="item.questionsTypeName" :name="index">
				<ul class="nav-left">
					<li @click="commonTopic(info, info.id)" v-for="(info, k) in item.questionTypeList" :key="k">
						<template v-if="info.icon">
							<i class="zxwj-iconfont" :class="info.icon"></i>
							{{ info.label }}
						</template>

						<div v-else :class="{ iconActive: selectId == info.id }" style="margin: 0px auto">
							<i class="zxwj-iconfont" :class="info.iconUrlSelection" :style="{ color: selectId == info.id ? '#0080ff' : '' }"></i>
							{{ info.label }}
						</div>
						<span :style="{ color: selectId == info.id ? '#0080ff' : '' }" style="font-size: 13px;">{{ info.questionsTypeName }}</span>
					</li>
				</ul>
			</el-collapse-item>
		</el-collapse>
		<div v-if="type" class="batch-add-box"><p class="btn" @click="batchAddVisible = true">批量添加题型</p></div>
		<el-dialog class="batch-add-dialog" title="导入题目" :visible.sync="batchAddVisible" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
			<ImportQuestion key="importQuestion" ref="importQuestion" v-if="type == 'wj'" :path="'/questionTypeList'"></ImportQuestion>
			<ExamImportQuestion key="examImportQuestion" ref="examImportQuestion" v-if="type == 'ks'" :path="'/questionTypeList'"></ExamImportQuestion>
			<span slot="footer" class="dialog-footer">
				<el-button @click="batchAddVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import ImportQuestion from '@/page/myQuestionnaire/importQuestion.vue';
import ExamImportQuestion from '@/page/myExam/examImportQuestion.vue';
export default {
	name: 'QuestionTypeList',
	components: {
		ImportQuestion,
		ExamImportQuestion
	},
	props: {
		typeObj: {
			type: Array,
			default: () => {
				return [];
			}
		},
		type: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			selectId: -1,
			collapseVisible: [],
			batchAddVisible: false
		};
	},
	created() {
		this.typeObj.forEach((info, index) => {
			this.collapseVisible.push(index);
		});
		// console.log('题型1111111111111', this.typeObj);
		// console.log('题型1111111111111', this.collapseVisible);
	},
	mounted() {},
	methods: {
		commonTopic(item, id) {
			this.selectId = id;
			this.$emit('commonTopic', item);
		},
		submit() {
			let refName = this.type == 'ks' ? this.$refs.examImportQuestion : this.$refs.importQuestion;
			if (this.type == 'wj') {
				refName.getJumpLogic();
			}
			this.$emit('batchAddQues', refName.paper.questionsList);
			this.batchAddVisible = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.QuestionTypeList {
	height: 100%;
	width: 100%;
}
.nav-left .zxwj-iconfont {
	font-size: 20px;
	color: #000;
}
.nav-left li {
	cursor: pointer;
}

.nav-left {
	display: flex;
	flex-wrap: wrap;
	border-left: 1px solid #ccc;
}
.nav-left i {
	display: block;
}
.nav-left li:nth-child(1),
.nav-left li:nth-child(2),
.nav-left li:nth-child(3) {
	border-top: 1px solid #ccc;
}
.nav-left li {
	width: calc(100% / 3);
	height: 70px;
	border-right: 1px solid #ccc;
	border-bottom: 1px solid #ccc;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
}

.iconActive {
	color: #0080ff;
}
.batch-add-box {
	margin: 20px 0 30px 0;
	.btn {
		text-align: center;
		font-size: 14px;
		border: 1px solid #ccc;
		line-height: 52px;
		border-radius: 2px;
		cursor: pointer;
	}
}
.batch-add-dialog {
	/deep/.el-dialog {
		width: 1000px;
	}
	/deep/.el-dialog__body {
		padding: 0;
	}
}
</style>
